import * as React from 'react';
import { useState, useEffect, ReactNode } from 'react';
import { Tooltip } from 'antd';
import usePortalService from '../../services/PortalService';
import { Candidate } from '../../types';
import styled, { css } from "styled-components";
import { useNavigate } from 'react-router-dom';

import star from '../../images/star.svg';
import emptyLike from '../../images/emptyLike.svg';
import fillLike from '../../images/fillLike.svg';
import emptyIconProfile from '../../images/emptyIconProfile.svg';

const NameCard = styled.h1<{ $isViewed?: boolean; }>`
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    display: inline-block;
    color: #2196F3;
    cursor: pointer;
    margin-bottom: 4px;
    ${props => props.$isViewed && css`
        color: #BB6BD9;
    `}
`;

type BasicCandidateCardProps = {
    candidate: Candidate,
    children: ReactNode,
    link?: string,
    isView?: boolean
};

export const BasicCandidateCard = ({ candidate, children, link, isView = false }: BasicCandidateCardProps) => {
    const { addInFavoriteProfiles, deleteFromFavoriteProfiles, getAvatar } = usePortalService();
    const navigate = useNavigate();

    const [isFavorite, setFavorites] = useState(candidate?.isFavorite)
    const [avatar, setAvatar] = useState(emptyIconProfile)
    const find = false;

    const favouriteHandle = async (e: React.MouseEvent) => {
        e.preventDefault();
        const result = isFavorite 
            ? await deleteFromFavoriteProfiles({ profileId: String(candidate.id) }) 
            : await addInFavoriteProfiles({ profileId: String(candidate.id) })
        if (result.success) {
            setFavorites(!isFavorite)
        }
    };

    const nameClickHandle = () => {
        if (link) {
            navigate(link);
            sessionStorage.setItem("scrollPosition", JSON.stringify(window.scrollY));
        }
    }
    
    useEffect(() => {
        if (candidate.avatarId) {
            getAvatar(candidate.avatarId)  
                .then(result => {
                    setAvatar(result)
                })
        } 
        setFavorites(candidate.isFavorite)
    }, [candidate]);

    return (
        <div className="candidate-card" key={candidate.id}>
            <div className="different-edges-container" style={{marginBottom: '24px'}}>
                <div className="left-edge">
                    <img src={avatar} className="avatar" style={{marginRight:'16px'}} key={candidate.avatarId} alt=''/>
                </div>
                <div className="left-edge">
                    <div className="header-card" onClick={() => nameClickHandle()}>
                        {(isView) ? <NameCard $isViewed> {candidate.fullName} </NameCard> : <NameCard> {candidate.fullName} </NameCard>}
                        {(find) && <div className="find-candidate-card"> Ищу работу, стажировку </div>}
                    </div>
                    <div>
                        <div className="row-container">
                            <img src={star} sizes="16px" style={{marginTop:'-5px'}} alt=''/>
                            <p className="hours-number" style={{ marginBottom: '4px' }}>
                                {candidate.ratingRTSIM}
                            </p>
                            <Tooltip 
                                placement='bottom'
                                title="Рейтинг РТСИМ - рейтинг, основанный на данных по использованию компьютерных тренажеров РТСИМ.Карьера.">
                                <h6 style={{ marginBottom: '4px' }}>
                                    Рейтинг РТСИМ
                                </h6>
                            </Tooltip>
                        </div>
                        <p style={{ marginBottom: '4px' }}> {candidate.educationalInstitution} </p>
                        {(candidate.specialtyNumber || candidate.specialtyName) && <p style={{ marginBottom: '4px' }}> {candidate.specialtyNumber}&nbsp;{candidate.specialtyName} </p>}
                        <p> {candidate.city} </p>
                    </div>
                </div>
            </div>
            <div className="different-edges-container">
                <div className="left-edge">
                    {children}
                </div>
                <div className="right-edge" style={{paddingTop:'5px'}}>
                    <div className="ant-btn-text" style={{cursor:'pointer', height:'22px', textAlign:'right'}} onClick={favouriteHandle}>
                        {isFavorite === true
                            ? <div><img src={fillLike} alt=''/> В избранном </div>
                            : <div><img src={emptyLike} alt=''/> Сохранить в избранное</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}